// extracted by mini-css-extract-plugin
export var connectionButton = "_b6-1";
export var rightPanel = "_b6-3";
export var stepDescription = "_b6-2";
export var stepIcon = "_b6-0";